import "./App.css";
import TitleBar from "./components/TitleBar";
import WelcomeSection from "./components/index_sections/Welcome";
import ProjectsSection from "./components/index_sections/Projects";

function App() {
  let skipIntro = false;
  let defaultVisibility = skipIntro ? "visible" : "invisible";

  return (
    <div className="App h-screen">
      <TitleBar />
      <WelcomeSection defaultVisibility={defaultVisibility} />
      <ProjectsSection defaultVisibility={defaultVisibility} />
    </div>
  );
}

export default App;
